// extracted by mini-css-extract-plugin
export default {"-large":"W6C3kCf6TED27b3dvDd2","container":"zLvSG97OKiDu6qIK4Foa"};